module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0048.jpg?v=ae914a34";